<template>
  <NuxtLayout :name="user ? 'default' : 'marketing'">
    <LoggedInIndex v-if="user" />
    <LoggedOutIndex v-else />
  </NuxtLayout>
</template>
<script lang="ts" setup>
import LoggedInIndex from "./LoggedInIndex.vue";
import LoggedOutIndex from "./LoggedOutIndex.vue";

definePageMeta({ layout: false, authenticated: false });

const user = useUser();
</script>
